import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Input,
  InputAdornment,
  Paper,
  Typography,

} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useDispatch } from "react-redux";

import { getAllCountries, getUserCategory } from "../../redux/auth/authActions";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import useUser from "../../hooks/useUser";
import useSubscription from "../../hooks/useSubscription";
import { fetchSubPlans } from "../../redux/subscriptions";
import { PlusIcon } from "../../assets/icons/Icons";
import SponsorPayment from "./SponsorPayment";
import { useNotifications } from "../notifications/notifications";
import {
  getLgaByStateId,
  getStatesByCountryId,
  getWaecApprovedSchools,
} from "../../redux/settings/settingsActions";

import SponsorAsynchronous from "../Settings/Autocomplete/SponsorAsynchronous";
import { GetOfflinePayment, sendOfflinePayment } from "../../redux/offlinePayment/offlinePaymentActions";
import useSettings from "../../hooks/useSettings";



const SingleOfflinePaymentForm = ({ openSinglePayment, setOpenSinglePayment, handleSinglePayment, getAllSponsor, setToastState, closeModal, }) => {
  const dispatch = useDispatch();
  const user = useUser();

  const { userCategory, isLoading, userInfo } = user;
   const { waecSchoolsData, waecSchoolsLoading } =
      useSettings();
  const subscription = useSubscription();
  const { allSubPlan, loading } = subscription;
  const [selectedSponsor, setSelectedSponsor] = useState("");
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState("");

  const [selectedUserType, setSelectedUserType] = useState("");
  const [selectedCatOrder, setSelectedCatOrder] = useState(null)
  const [numberOfLicense, setNumberOfLicense] = useState(1);
  const [selectedSubscriptionAmount, setSelectedSubscriptionAmount] = useState(0);
  const [totalLicenses, setTotalLicenses] = useState(0);
  const initialFormValues = {
    firstName: "",
    lastName: "",
    surName: "",
    super: "Super",
    school: "School",
    schoolName: "",
    schoolAddress: "",
    countryId: 0,
    stateId: 0,
    sponsorId: 0,
  };

  const [formValues, setFormValues] = useState({ ...initialFormValues });
  const [selectedSchools, setSelectedSchools] = useState([]);
  const [values, setValues] = useState({ label: "", value: 0 });
  const [stateValues, setStateValues] = useState({ label: "", value: 0 });
  const [lgaValues, setLgaValues] = useState({ label: "", value: 0 });
  const [schoolValues, setSchoolValues] = useState({ label: "", value: 0 });
  const [sponsorValue, setSponsorValue] = useState({ label: "", value: 0 });
  const [packageOrder, setPackageOrder] = useState(0)
  const [ deleteModal, setDeleteModal] = useState(false);
  // const [ToastState, setToastState] = useNotifications();
  const [openPayment, setOpenPayment] = useState(false)
  const [showPriceField, setShowPriceField] = useState(false);
  const [pricePerLicense, setPricePerLicense] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
      const [totalUndiscountedAmount, setTotalUndiscountedAmount] = useState(0);

  const handleChange = (event) => {
    const { name, value } = event.target;
    // if (name == 'emailAddress') {
    //   setIsEmailValid(emailRegex.test(value));
    // }
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };


  useEffect(() => {
    setTotalLicenses(calculateTotalLicenses())
  }, [selectedSchools, numberOfLicense])
  useEffect(() => {
    setTotalLicenses(calculateTotalLicenses())
  }, [selectedSchools, numberOfLicense])

  useEffect(() => {
    dispatch(getUserCategory());
  }, [])

  const handleIncrement = () => {
    setNumberOfLicense((prevCount) => prevCount + 1);
  };
  const handleDecrement = () => {
    if (numberOfLicense > 1) {
      setNumberOfLicense((prevCount) => prevCount - 1);
    }
  }
  // functionality that add school and licences
  const handleOpenPaymentView = () => {
    if (schoolValues.value !== 0 && numberOfLicense > 0 && selectedSubscriptionId !== "") {
      const schoolName = schoolValues.label || schoolValues.name;
      const subscriptionModelIds = allSubPlan?.data?.find((sub) => sub.SubscriptionModelId === selectedSubscriptionId)?.PackageName;
      
      // Check if this school with the same license count already exists
      const isDuplicate = selectedSchools.some(
        school => school.schoolName === schoolName && school.licenseNo === numberOfLicense && school.subscriptionModelId === selectedSubscriptionId
      );

      if (isDuplicate) {
        // Alert the user that this entry already exists
        setToastState({
          isOpen: true,
          message: (`${schoolName} with ${numberOfLicense} licenses is already added.`),
          severity: "error",
        });

        return;
      }
      const newEntry = {
        id: schoolValues.value,
        schoolName,
        licenseNo: numberOfLicense,
        subscriptionModelId,
      };

      setSelectedSchools([...selectedSchools, newEntry]);
      setOpenPayment(true);

    } else {
      setToastState({
        isOpen: true,
        message: (`No school selecected.`),
        severity: "error",
      });
    }
  }

  useEffect(() => {
    dispatch(getAllCountries());
    
  }, []);

  useEffect(() => {
    const calculateTotalAmount = () => {
      const totalLicenses = calculateTotalLicenses();
      const calculatedTotalAmount = pricePerLicense * totalLicenses;
      setTotalAmount(calculatedTotalAmount);
    };

    calculateTotalAmount();
  }, [pricePerLicense, selectedSchools, numberOfLicense]);


  useEffect(() => {
    const calculateTotalUndiscountedAmount = () => {
      // const totalLicensesUndiscounted = calculateTotalLicenses();
      const calculatedTotalAmountUndiscounted = 
      selectedSubscriptionAmount * numberOfLicense;
      setTotalUndiscountedAmount(calculatedTotalAmountUndiscounted);
    };

    calculateTotalUndiscountedAmount();
  }, [selectedSubscriptionAmount, selectedSchools, numberOfLicense]);

  const handleRemoveSchool = (id) => {
    setSelectedSchools(selectedSchools.filter(school => school.id !== id));

    if (selectedSchools.length <= 1) {
      setOpenPayment(false);
    }
  };

  const calculateTotalLicenses = () => {
    if (selectedSchools.length === 0) {

      return numberOfLicense; // Return the value from the input field
    }
    return selectedSchools.reduce((total, school) => total + school.licenseNo, 0);

  };

  const calculateTotalLicensesUnDiscounted = () => {
    if (selectedSchools.length === 0) {
      return numberOfLicense; // Return the value from the input field
    }
    return selectedSchools.reduce((total, school) => total + school.licenseNo, 0);
  };


    const onSuccess = (res) => {
      closeModal(true);

       dispatch(GetOfflinePayment())
      
      setToastState({
        isOpen: true,
        severity: "success",
        message: res.msg,
      });
      setTimeout(() => {}, 1000);
    };

    const onFail = (res) => {
      setToastState({
        isOpen: true,
        severity: "error",
        message: res.msg,
      });
      setTimeout(() => {
        // navigate('/dashboard/home')
      }, 3000);
      closeModal(true);
    };

  //   useEffect(() => {
  //     dispatch(fetchSponsorSubscriptions(sponsorId));
  //   }, []);

  //   const onSelectChange = async (event) => {
  //     const selectedValue = event.target.value;
  //     setSelectedSponsor(selectedValue);
  //     const sponsorId = selectedValue;

  //     dispatch(fetchSchoolSubscriptionsBySponsorId(schoolId, sponsorId));
  //   };


  const stateByCountryFailure = (res) => {
    if (res !== 1) {
      setToast({
        isOpen: true,
        message: "An error occured!",
        severity: "error",
      });
    }
  };

  const handleChangess = (event) => {
    const { name, value } = event.target;
    // setInput({ ...input, schoolName: value });
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const handleChanges = (event) => {
    const { name, value } = event.target;
    // setInput({ ...input, schoolAddress: value });
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };


  //functionality for country
  const countryHandler = (event, val) => {
    if (event) {
      setStateValues({ label: "", value: 0 });
      // setInput({ ...input, countryId: val.value });
      setFormValues({
        ...formValues,
        countryId: val.value,
      });

      dispatch(getStatesByCountryId(val?.value, stateByCountryFailure));
    }
  };


  const updateSponsorValue = (value) => {
    setFormValues({
      ...formValues,
      sponsorId: value.value
    });
    setSponsorValue({
      ...values,
      label: value.label,
      value: value.value
    });
  }

  const sponsorHandler = (event, val) => {
    if (event) {
      setSponsorValue()
      setFormValues({
        ...formValues,
        sponsorId: val.value,
      })
    }
  }

  const updateValue = (value) => {
    setFormValues({
      ...formValues,
      countryId: value.value,
    });
    // setInput({ ...input, countryId: value.value });
    setValues({
      ...values,
      label: value.label,
      value: value.value,
    });
  };
  const stateHandler = (event, val) => {
    if (event) {
      setLgaValues({ label: "", value: 0 });
      setFormValues({
        ...formValues,
        stateId: val.value,
      });

      dispatch(getLgaByStateId(val?.value, lgaByStateFailure));
    }
  };

  const updateStateValue = (value) => {
    setFormValues({
      ...formValues,
      stateId: value.value,
    });
    // setInput({ ...input, stateId: value.value });
    setStateValues({
      ...values,
      label: value.label,
      value: value.value,
    });
  };

  const lgaHandler = (event, val) => {
    if (event) {
      setSchoolValues({ label: "", value: 0 });
      setFormValues({
        ...formValues,
        lgaId: val.value,
      });

      dispatch(
        getWaecApprovedSchools(
          formValues?.countryId,
          formValues?.stateId,
          val?.value,
          schoolFailure
        )
      );
    }
  };

  const updateLgaValue = (value) => {
    setFormValues({
      ...formValues,
      lgaId: value.value,
    });
    // setInput({ ...input, lgaId: value.value });
    setLgaValues({
      ...values,
      label: value.label,
      value: value.value,
    });
  };

  const schoolHandler = (event, val) => {
    if (event) {
      setFormValues({
        ...formValues,
        schoolId: val.value,
      });
    }
  };

  const updateSchoolValue = (value) => {
    setFormValues({
      ...formValues,
      WAECSchoolID: value.value,
    });
    // setInput({ ...input, WAECSchoolID: value.value });
    setSchoolValues({
      ...values,
      label: value.label,
      value: value.value,
    });
  };

  const lgaByStateFailure = (res) => {
    if (res !== 1) {
      setToast({
        isOpen: true,
        message: "An error occured!",
        severity: "error",
      });
    }
  };

  const schoolFailure = (res) => {
    if (res !== 1) {
      setToast({
        isOpen: true,
        message: "An error occured!",
        severity: "error",
      });
    }
  };

// modal for confirmation of payment


  //Fundtion to send the data to the server
  const handleSendOfflinePayment = () => {
    const payload = {
      subscriptionModelId: selectedSubscriptionId,
      countryId: values.value,
      quantity: totalLicenses,
      stateId: stateValues.value,
      lga: lgaValues.value,
       totalAmount: totalUndiscountedAmount !== 0 ?  totalUndiscountedAmount: totalAmount,
      userCategoryId: selectedUserType,
      sponsorId: sponsorValue.value !== 0 ? sponsorValue.value: null,
      schoolIds: selectedSchools && selectedSchools.length > 0 ?
      selectedSchools.map(school => ({
        schoolId: waecSchoolsData.filter((data) => data.WAECSchoolID == school.id)?.SchoolId,
        licenseNo: school.licenseNo || 0,
        subscriptionModelId: 0
      }))
      : [{
        schoolId: waecSchoolsData?.find((data) => data.WAECSchoolID == schoolValues.value)?.SchoolId,
        licenseNo: numberOfLicense,
        subscriptionModelId: selectedSubscriptionId,
        }]
    }
    dispatch(sendOfflinePayment(payload, onSuccess,onFail))


  }



  const handleChangeCountry = (event) => {
    const value = event.target.value;
    // setInput({ ...input, countryId: value });
    dispatch(getStatesByCountryId(value));
  };


  const handleSelectedUserChange = (event) => {
    const typeid = event.target.value;
    setSelectedUserType(typeid);
    const category = userCategory?.find((cat) => cat.CategoryID === typeid)?.CategoryOrder;
    setSelectedCatOrder(category);
    if (typeid) {
      dispatch(fetchSubPlans(typeid));
    }
  };
  const handleSubscriptionChange = (event) => {
    const subId = event.target.value;
    setSelectedSubscriptionId(subId);
    const subscriptionAmount = allSubPlan?.data?.find((sub) => sub.SubscriptionModelId === subId)?.Amount;
    const subscriptionOrder = allSubPlan?.data?.find((sub) => sub.SubscriptionModelId === subId)?.PackageOrder;
    setPackageOrder(subscriptionOrder)
    setSelectedSubscriptionAmount(subscriptionAmount);
  };

  const subAmount = selectedSubscriptionAmount;

  const subtotal = parseInt(subAmount) * numberOfLicense;

  //function to remove teacher and parents from the arraay
  const filterUserCategory = userCategory?.filter(
    (category) =>
      category?.CategoryName?.replace(/\s/g, "").toLowerCase() !== "teacher" &&
      category?.CategoryName?.replace(/\s/g, "").toLowerCase() != "parent" &&
      category?.CategoryName?.replace(/\s/g, "").toLowerCase() != "student/candidate"
  );

  return (
    <>
      <div className="bg-white rounded-2xl ">
        <div className="pb-6 px-12">
          <p className="text-lg text-slate-500">Licence Payemnt Details</p>
          <p>All fields marked (*) are required</p>
        </div>

        <div className="flex flex-col gap-[24px] px-12 mb-8">
          <FormControl>
            <InputLabel id="demo-simple-select-label">User type</InputLabel>
            <Select
              name="UserType"
              labelId="demo-simple-select-label"
              label=" User Type"
              // className="min-w-full h-[46px] bg-[#fff] rounded-[10px] font-normal text-[#3d3d3d] text-base px-4  border border-black"
              onChange={handleSelectedUserChange}
              value={selectedUserType}
              disabled={isLoading}
            >
              {/* <MenuItem value="">User Type*</MenuItem> */}
              {filterUserCategory?.map((type, index) => (
                <MenuItem key={index}
                  value={type.CategoryID}
                >
                  {`${type.CategoryName}`}
                </MenuItem>
              ))
              }
            </Select>
          </FormControl>

        </div>

        {selectedCatOrder == 3 ? (<>
          <div className="flex flex-col gap-[24px] px-12 mb-8">
            <SponsorAsynchronous
              updateSponsorValue={updateSponsorValue}
              sponsorHandler={sponsorHandler}
              sponsorValue={sponsorValue}

            />
          </div>
        </>) : null}

        <div className="flex flex-col gap-[24px] px-12 mb-8">
          <FormControl>
            <InputLabel id="demo-simple-select-label">Subscription Plan</InputLabel>
            <Select
              name="Subscription"
              labelId="demo-simple-select-label"
              // id="Subscription"
              label="Subscription Plan"
              // className="min-w-full h-[46px] bg-[#fff] rounded-[10px] font-normal text-[#3d3d3d] text-base px-4  border border-black"
              onChange={handleSubscriptionChange}
              value={selectedSubscriptionId}
            // disabled={isLoading}
            >
              <MenuItem value="">Subcription Plan*</MenuItem>
              {allSubPlan?.data?.map((plan, index) => (
                <MenuItem key={index}
                  value={plan.SubscriptionModelId}
                >
                  {`${plan.PackageName}`}
                </MenuItem>
              ))
              }
            </Select>
          </FormControl>
        </div>

        <SponsorPayment
          countryHandler={countryHandler}
          updateValue={updateValue}
          values={values}
          setValues={setValues}
          updateStateValue={updateStateValue}
          stateHandler={stateHandler}
          lgaHandler={lgaHandler}
          updateLgaValue={updateLgaValue}
          schoolHandler={schoolHandler}
          stateValues={stateValues}
          lgaValues={lgaValues}
          updateSchoolValue={updateSchoolValue}
          schoolValues={schoolValues}
          handleChangeCountry={handleChangeCountry}
        />


        <div className="flex flex-col gap-[24px] px-12 mb-8">
          <FormControl variant="standard" fullWidth>
            <InputLabel
              htmlFor="bootstrap-input"
              sx={{ fontWeight: 800, fontSize: "18px", color: "#313131" }}
            >
              Number of enrollment?
            </InputLabel>
            <Input
              id="bootstrap-input"
              type="number"
              value={numberOfLicense}
              onChange={(e) => setNumberOfLicense(e.target.valueAsNumber || 0)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton aria-label="add" onClick={handleDecrement}>
                    <RemoveIcon />
                  </IconButton>
                  <IconButton aria-label="add" onClick={handleIncrement}>
                    <AddIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </div>

        {selectedCatOrder == 3 ? (<div className="flex flex-cols-2 gap-4 px-12 mb-8 justify-between ">
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showPriceField}
                  onChange={(e) => setShowPriceField(e.target.checked)}
                />
              }
              label="Discounted amount"
            />
          </div>
          <div>
            <Button

              variant="contained"
              size="small"
              onClick={handleOpenPaymentView}>
              Add Multiple Payment
            </Button>
          </div>

        </div>) : <div className="flex flex-cols-2 gap-4 px-12 mb-8  ">

          <FormControlLabel
            control={
              <Checkbox
                checked={showPriceField}
                onChange={(e) => setShowPriceField(e.target.checked)}
              />
            }
            label="Discounted amount"
          />
        </div>}
        {openPayment && selectedCatOrder == 3 ? (<div className="flex flex-col gap-[24px] px-12 mb-8">
          <table class="border-collapse border border-black-800 ...">
            <thead>
              <tr>
                <th class="border border-black-600 ...">SchoolName</th>
                <th class="border border-black-600 ...">LicenseNo</th>
                <th class="border border-black-600 ...">Subscription</th>
                <th class="border border-black-600 ...">Action</th>

              </tr>
            </thead>
            <tbody >
              {selectedSchools.map((ct) => (
                <tr key={ct.id}>
                  <td class="border border-black-900 ...">{ct.schoolName}</td>
                  <td class="border border-black-300 ...">{ct.licenseNo}</td>
                  <td class="border border-black-300 ...">{ct.subscriptionModelId}</td>
                  <td>

                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={() => handleRemoveSchool(ct.id)}
                    >
                      Cancel
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>) : null}
        {/*on check of the box*/}

        {showPriceField ? (
          <>
            <div className="flex flex-cols-2 gap-2 px-12 mb-8 justify-between">
              <div>
                <FormControl variant="standard" fullWidth>
                  <InputLabel htmlFor="price-input">Price per license (₦)</InputLabel>
                  <Input
                    id="price-input"
                    type="number"
                    value={pricePerLicense}
                    onChange={(e) => setPricePerLicense(e.target.valueAsNumber || 0)}
                  />
                </FormControl>
              </div>


              {/* Total amount calculation */}
              <div className="mt-3 p-2 bg-gray-100 rounded">
                <Typography variant="h6">
                  Total Amount: ₦{ totalAmount.toFixed(2)}
                </Typography>
              </div>
            </div>
            <div className="flex flex-cols-2 gap-4 px-12 mb-8 justify-between ">
              <div>
                Total Licences
              </div>
              <div>
                {totalLicenses}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-cols-2 gap-4 px-12 mb-8 justify-between ">
              <div>
                Total Licences
              </div>
              <div>
                {totalLicenses}
              </div>
            </div>
            <div className="flex flex-cols-2 gap-4 px-12 mb-8 justify-between ">
              <div>
                Total Amount
              </div>
              <div>
                ₦{ totalUndiscountedAmount.toFixed(2)}
              </div>
            </div>
          </>
        )}


        <div className="grid justify-items-end px-12 w-full mb-10">
          <button
            className={`rounded-[6px] bg-[#40499D] px-[26px] py-4 text-[12px] text-white text-sm ${selectedCatOrder == 1
              ? (!formValues.firstName || !formValues.lastName || !selectedUserType || !selectedSubscriptionId)
                ? "opacity-50 cursor-not-allowed"
                : ""
              : selectedCatOrder == 2
                ? (!values.value || !selectedUserType || !selectedSubscriptionId || !stateValues.value || !lgaValues.value || !schoolValues.value)
                  ? "opacity-50 cursor-not-allowed"
                  : ""

                : selectedCatOrder == 3
                  ? (!sponsorValue.value || !values.value || !selectedUserType || !selectedSubscriptionId || !stateValues.value || !lgaValues.value || !schoolValues.value)
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                  : ""
              }`}
            onClick={()=>setDeleteModal(true)}
            disabled={
              selectedCatOrder == 1
                ? (!formValues.firstName ||
                  !formValues.lastName ||
                  !selectedUserType ||
                  !selectedSubscriptionId ||
                  isLoading)
                : selectedCatOrder == 3
                  ? (!formValues.countryId ||
                    !formValues.sponsorId ||
                    !selectedUserType ||
                    !selectedSubscriptionId)
                  : false
            }
          >
            {!isLoading ? (
              <>
                <PlusIcon size={15} className="mr-2" /> Create Payment
              </>
            ) : (
              <DataUsageIcon size={24} className="animate-spin ml-4" />
            )}
          </button>
        </div>
      </div>
 <Dialog
        open={deleteModal}
        onClose={()=>setDeleteModal(true)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Paper sx={{ p: 1 }}>
            <h3 className="e-study-heading-three">
              Are you sure you want procced with the payment?
            </h3>
          </Paper>
        </DialogContent>
        <DialogActions>
          <div className="flex justify-between items-center space-x-3 lg:space-x-9">
            <span
              className="e-study-primary cursor-pointer"
              onClick={()=> setDeleteModal(false)}
            >
              No
            </span>
            <button
              onClick={ handleSendOfflinePayment}
              style={{ backgroundColor: "#FA7E77" }}
              class="hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full"
            >
              Yes
            </button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SingleOfflinePaymentForm;
